import { ReactNode, useEffect, useState } from 'react';
import { defaultAppName } from '#features/app/consts';
import { useUpdateAppIcon } from '#features/app/useUpdateAppIcon';
import { useChangeDocumentTitle } from '#lib/useChangeDocumentTitle';
import { destroyPlatform, initializePlatform } from '#platform/web/init';
import { getLogger } from '#services/logging';
import { Shell } from '../shared/Shell';
import { WebPlatform } from './WebPlatform';

const logger = getLogger('web-platform-shell');

type WebPlatformProps = {
  /**
   * An optional ReactNode to render while logging in and logging out
   */
  fallback?: ReactNode;
};

export const WebPlatformShell = (props: WebPlatformProps) => {
  const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(
    null,
  );

  useChangeDocumentTitle(defaultAppName);

  useEffect(() => {
    const init = async (node: HTMLDivElement) => {
      try {
        await initializePlatform(node);
        logger.debug('Web platform initialized successfully.');
      } catch (e) {
        logger.error('Failed to initialize web platform.', e);
      }
    };
    if (containerNode) {
      init(containerNode);
    }

    return () => {
      destroyPlatform();
    };
  }, [containerNode]);

  useUpdateAppIcon();

  return (
    <Shell fallback={props.fallback} alternativeRoute="/logon">
      <WebPlatform platformContainerRef={setContainerNode} />
    </Shell>
  );
};
